<template>
    <div>
        <span class="fs-14 pl-1 fw-700">Подтверждающие документы:</span>
        <b-table id="my-table" :fields="fields" :items="documents" class="table-atmo mb-0" small responsive>
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>
            <template #cell(document)="data">
                <a class="fs-14 col-form-label d-inline-block" style="color: var(--green-color) !important" :href="$getAttachmentDownloadLink(data.item.attachment.file_id)" target="_blank">{{ data.item.attachment.name }}</a>
            </template>
        </b-table>
    </div>
</template>

<script>

export default {
    name: 'additional-supplier-requirements-view-table',
    props: {
        documents: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-0', thClass: 'py-0', thStyle: { width: '1px' } },
                { key: 'description', label: 'Описание', tdClass: 'align-text-top py-0 text-nowrap', thClass: 'py-0' },
                { key: 'reason', label: 'Причина или цель установки требования', tdClass: 'align-text-top py-0 text-nowrap', thClass: 'py-0' },
                { key: 'document', label: 'Документ', tdClass: 'align-text-top py-0 text-nowrap', thClass: 'py-0' },
            ]
        };
    }
};
</script>
